import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=46d9535a&scoped=true"
import script from "./RouteList.vue?vue&type=script&lang=js"
export * from "./RouteList.vue?vue&type=script&lang=js"
import style0 from "./RouteList.vue?vue&type=style&index=0&id=46d9535a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d9535a",
  null
  
)

export default component.exports